import { ParticipantsProvider } from "./ParticipantsContext.js";
import Participants from "./Participants.js";

const ParticipantsIndex = () => {
  return (
    <ParticipantsProvider>
      <Participants />
    </ParticipantsProvider>
  );
};
export default ParticipantsIndex; 
